import { SVGProps } from 'react';

const Checkmark = ({
  width = 13,
  height = 10,
  fill = '#FF8200',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 10"
    {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.97235 8.32717L12.6274 1.67208L10.9554 0L4.30027 6.65508L1.67208 4.0269L0 5.69898L2.62818 8.32717L2.62743 8.32792L4.29952 10L4.30027 9.99925L4.30029 9.99928L5.97238 8.32719L5.97235 8.32717Z"
      fill={fill}
    />
  </svg>
);

export default Checkmark;
